import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { PenelopDao, PenelopEventSearch } from '@app/dao/penelop/penelop.dao';
import { PrTable, PrTableColumn } from '@app/components/pr-table/pr-table.component';
import { take, takeWhile } from 'rxjs';

interface EventType {
  [key: string]: string;
}

@Component({
    selector: 'asset-events-table',
    templateUrl: './asset-events-table.component.html',
    styleUrls: ['./asset-events-table.component.scss'],
    standalone: false
})
export class AssetEventsTableComponent implements OnInit, OnDestroy {
  @Input() contratId: string;
  @Input() hideEmptyFee = false;

  alive = true;
  loading = false;
  eventsTableData: any[];
  eventTypes: EventType = {};

  eventsColumnsDefinition: PrTableColumn[] = [];

  private buildColumns(hasFees: boolean): PrTableColumn[] {
    const cols = [
      new PrTableColumn('Date', 'date', 'date'),
      new PrTableColumn('Type', 'type', 'badge'),
      new PrTableColumn('Valeur', 'amount', 'currency'),
    ];
    if (hasFees || !this.hideEmptyFee) {
      cols.push(new PrTableColumn('Frais', 'fee', 'currency'));
    }
    return cols;
  }

  constructor(private penelopDao: PenelopDao) {}

  ngOnInit() {
    this.eventsColumnsDefinition = this.buildColumns(false);
    if (this.contratId) {
      this.loadEventTypes();
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

  loadEventTypes() {
    this.penelopDao
      .getEventTypes()
      .pipe(takeWhile(() => this.alive))
      .subscribe(eventTypes => {
        eventTypes.forEach(ref => (this.eventTypes[ref.id] = ref.value));
        this.loadEvents();
      });
  }

  loadEvents() {
    this.loading = true;

    const criteria: PenelopEventSearch = {
      status: ['VAL', 'COR'],
      sorts: [
        {
          property: 'DATE',
          direction: 'DESC',
        },
      ],
    };

    this.penelopDao
      .searchEvenements(this.contratId, criteria)
      .pipe(take(1))
      .subscribe(
        events => {
          this.eventsTableData = events.content.map(event => ({
            date: event.date,
            amount: event.amount,
            type: this.eventTypes[event.type] || event.type,
            fee: event.fee ? event.fee : null,
          }));
          const hasFees = this.eventsTableData.some(e => e.fee != null);
          this.eventsColumnsDefinition = this.buildColumns(hasFees);
          this.loading = false;
        },
        error => {
          console.error('Error loading events:', error);
          this.loading = false;
        },
      );
  }
}
